export default {
  // 使用的global變數一律定義在這裡,每個變數上面要附加註解說明用途
  'session': null,
  'landingComponent': 'Info',
  // 由某些操作連結要開啟其他功能時,原則上只要修改this.$bus.landingComponent即可
  // 但如果希望跳過去時可以帶參數決定那個view初始狀態,且還想要可以快速回去前一個動作的位置,需要特定機制與數據傳遞
  // 因為沒弄global的store,所以在這裡安排一個stack的陣列
  // 碰到有需要跳過去就新增兩個元素,先push自己的組件以備回來,再push一個目標組件與傳遞的子屬性參數物件
  // 每個索引頭的組件(被掛在landing page)都要在mounted裡
  'linkCallStack':[],
  //這是要被hook進來的function,外面傳進來,呼叫api發生登入憑證無效時,alert後call這個跳回登入
  'fnGoLogin': null,
  'fnShowInfo': null,
  'fnShowConfirm': null,
  'fnClosePopup':null,
  // filter form預設的input type,配置控制項時碰到類型符合以下者用b-form-input render
  'formInputTypes':[
    'text', 'password', 'email', 'number', 'url',
    'tel', 'date', `time`, 'range', 'color'
  ],
  // 提供額外機制來暫時隱藏手機版型的導覽列,如聊天功能視窗下面會壓到輸入送出的部分,當聊天組件被打開時就透過設定此屬性暫時隱藏,關閉時再重新恢復顯示
  hideMobileNavi:false,
  roleFunctionsMap: {
    'admin': [
      {"index":0,"FunTitle":"統計報表","actionComponent":"","imgUrl":require('../assets/images/money_on@2x.png'),
      subActions:[
        {"index":1,"FunTitle":"API呼叫","pathName": "api_statistics","actionComponent":"Statistics","imgUrl":require('../assets/images/management_on@2x.png')},   
        {"index":2,"FunTitle":"票券狀態報表","pathName": "ticket_report","actionComponent":"SalesViewTicketReport","imgUrl":require('../assets/images/management_on@2x.png')}, 
        {"index":3,"FunTitle":"課程核銷狀態","pathName": "ticket_status_report","actionComponent":"SalesViewTicketStatus","imgUrl":require('../assets/images/management_on@2x.png')},
        {"index":4,"FunTitle":"核銷失敗紀錄","pathName": "ticket_error_report","actionComponent":"StatisticsTicketError","imgUrl":require('../assets/images/management_on@2x.png')},
        // {"index":5,"FunTitle":"核銷失敗紀錄","pathName": "alert","actionComponent":"AlertModal","imgUrl":require('../assets/images/management_on@2x.png')}
      ]},
      {"index":1,"FunTitle":"課程管理","pathName": "ticket_manage","actionComponent":"Tickets","imgUrl":require('../assets/images/ticket_on@2x.png')},
      /*
      {"index":2,"FunTitle":"建立可候補排程","actionComponent":"TemplateSchedule","imgUrl":require('../assets/images/calendar_on@2x.png')},
      {"index":3,"FunTitle":"候補管理","actionComponent":"WaitlistAdmin","imgUrl":require('../assets/images/appointment_on@2x.png')},
      {"index":4,"FunTitle":"預約管理","actionComponent":"ReservationAdmin","imgUrl":require('../assets/images/appointment_on@2x.png')},
      */
      {
        "index":2,
        "FunTitle":"銷售管理組合",
        // "pathName": "sales_statistics",
        "actionComponent":"",
        "imgUrl":require('../assets/images/appointment_on@2x.png'),
        subActions:[
          // {
          //   "index":1,
          //   "FunTitle":"銷售數據",
          //   "pathName": "sales_statistics",
          //   "actionComponent":"SalesViewCombo",
          //   "imgUrl":require('../assets/images/appointment_on@2x.png'),
          // },
          {
            "index":1,
            "FunTitle":"銷售數據",
            "pathName": "sales_report",
            "actionComponent":"SalesReport",
            "imgUrl":require('../assets/images/appointment_on@2x.png'),
          },
          {
            "index":2,
            "FunTitle":"預約數據",
            "pathName": "reservation_statistics",
            "actionComponent":"ReservationChart",
            "imgUrl":require('../assets/images/appointment_on@2x.png'),
          },

          // {
          //   "index":2,
          //   "FunTitle":"退票數據",
          //   "pathName": "demo_chart",
          //   "actionComponent":"DemoChart",
          //   "imgUrl":require('../assets/images/appointment_on@2x.png'),
          // }          
        ]
      },
      /*{"index":3,"FunTitle":"劃位設定","actionComponent":"","imgUrl":require('../assets/images/appointment_on@2x.png'),subActions:[
        {"index":1,"FunTitle":"店家劃位設定","actionComponent":"StoreManage","imgUrl":require('../assets/images/appointment_on@2x.png')},
        {"index":2,"FunTitle":"店家公休日處理","actionComponent":"StoreRestDayManage","imgUrl":require('../assets/images/appointment_on@2x.png')},
      ]},*/
      {"index":3,"FunTitle":"供應商管理","pathName": "merchant_manage","actionComponent":"MerchantManage","imgUrl":require('../assets/images/management_on@2x.png')},
      /*{"index":5,"FunTitle":"內部使用","actionComponent":"","imgUrl":require('../assets/images/management_on@2x.png'),subActions:[
        {"index":1,"FunTitle":"建立可候補排程","actionComponent":"TemplateSchedule","imgUrl":require('../assets/images/calendar_on@2x.png')},
        {"index":2,"FunTitle":"候補管理","actionComponent":"WaitlistAdmin","imgUrl":require('../assets/images/appointment_on@2x.png')},
        {"index":3,"FunTitle":"預約管理","actionComponent":"ReservationAdmin","imgUrl":require('../assets/images/appointment_on@2x.png')},
      ]},*/
      {"index":4,"FunTitle":"請款/核銷","actionComponent":"","imgUrl":require('../assets/images/management_on@2x.png'),subActions:[
          {"index":1,"FunTitle":"核銷紀錄查詢","pathName": "service_execution_list","actionComponent":"ServiceExecutionList","imgUrl":require('../assets/images/appointment_on@2x.png')},
          {"index":2,"FunTitle":"核銷日曆查看","pathName": "service_execution_view","actionComponent":"ServiceExecutionView","imgUrl":require('../assets/images/appointment_on@2x.png')},
          {"index":3,"FunTitle":"請款單查看","pathName": "paymentform_manage","actionComponent":"PaymentFormAdminView","imgUrl":require('../assets/images/appointment_on@2x.png')},
      ]},
      {"index":5,"FunTitle":"客服處理","actionComponent":"","imgUrl":require('../assets/images/management_on@2x.png'),subActions:[
        {"index":1,"FunTitle":"票券處理","pathName": "ticket_process","actionComponent":"TicketProcess","imgUrl":require('../assets/images/management_on@2x.png')},        
        {"index":2,"FunTitle":"用戶評價查詢","pathName": "user_score_manage","actionComponent":"UserScoreManage","imgUrl":require('../assets/images/management_on@2x.png')},        
        {"index":3,"FunTitle":"訂單查詢處理","pathName": "orders","actionComponent":"OrderProcess",faicon:"receipt"},
        {"index":4,"FunTitle":"會員繼承","pathName": "member_process","actionComponent":"MemberProcess",faicon:"man"},
      ]},
      {"index":6,"FunTitle":"紙本作業","actionComponent":"","imgUrl":require('../assets/images/management_on@2x.png'),subActions:[
        {"index":1,"FunTitle":"紙本票處理","pathName": "print_paper_ticket","actionComponent":"PrintTest",faicon:"print"},
        {"index":2,"FunTitle":"紙本票銷退作廢","pathName": "paper_ticket_return","actionComponent":"PaperSalesReturn",faicon:"receipt"},
      ]},
      {"index":7,"FunTitle":"放款作業","pathName": "payment_operation","actionComponent":"PaymentOperation",faicon:"money-bill"},
    ],
    'admin_sales': [
      {"index":0,"FunTitle":"統計報表","actionComponent":"","imgUrl":require('../assets/images/money_on@2x.png'),subActions:[   
        {"index":1,"FunTitle":"課程核銷狀態","pathName": "ticket_status_report","actionComponent":"SalesViewTicketStatus","imgUrl":require('../assets/images/management_on@2x.png')},    
      ]},
      {"index":1,"FunTitle":"課程管理","pathName": "ticket_manage","actionComponent":"Tickets","imgUrl":require('../assets/images/ticket_on@2x.png')},
      /*
      {"index":2,"FunTitle":"建立可候補排程","actionComponent":"TemplateSchedule","imgUrl":require('../assets/images/calendar_on@2x.png')},
      {"index":3,"FunTitle":"候補管理","actionComponent":"WaitlistAdmin","imgUrl":require('../assets/images/appointment_on@2x.png')},
      {"index":4,"FunTitle":"預約管理","actionComponent":"ReservationAdmin","imgUrl":require('../assets/images/appointment_on@2x.png')},
      */
      {
        "index":2,
        "FunTitle":"銷售管理組合",
        // "pathName": "sales_statistics",
        "actionComponent":"",
        "imgUrl":require('../assets/images/appointment_on@2x.png'),
        subActions:[
          // {
          //   "index":1,
          //   "FunTitle":"銷售數據",
          //   "pathName": "sales_statistics",
          //   "actionComponent":"SalesViewCombo",
          //   "imgUrl":require('../assets/images/appointment_on@2x.png'),
          // },
          {
            "index":1,
            "FunTitle":"銷售數據",
            "pathName": "sales_report",
            "actionComponent":"SalesReport",
            "imgUrl":require('../assets/images/appointment_on@2x.png'),
          },
          {
            "index":2,
            "FunTitle":"預約數據",
            "pathName": "reservation_statistics",
            "actionComponent":"ReservationChart",
            "imgUrl":require('../assets/images/appointment_on@2x.png'),
          },
          // {
          //   "index":3,
          //   "FunTitle":"銷售數據",
          //   "pathName": "sales_report",
          //   "actionComponent":"salesReport",
          //   "imgUrl":require('../assets/images/appointment_on@2x.png'),
          // },
        ]
      },
      //{"index":3,"FunTitle":"做預約","actionComponent":"MakeReservation","imgUrl":require('../assets/images/appointment_on@2x.png')},
      /*{"index":3,"FunTitle":"店家管理","actionComponent":"","imgUrl":require('../assets/images/appointment_on@2x.png'),subActions:[
        {"index":1,"FunTitle":"店家劃位設定","actionComponent":"StoreManage","imgUrl":require('../assets/images/appointment_on@2x.png')},
        {"index":2,"FunTitle":"店家公休日處理","actionComponent":"StoreRestDayManage","imgUrl":require('../assets/images/appointment_on@2x.png')},
      ]},*/
      {"index":3,"FunTitle":"供應商管理","pathName": "merchant_manage","actionComponent":"MerchantManage","imgUrl":require('../assets/images/management_on@2x.png')},
      /*{"index":5,"FunTitle":"內部使用","actionComponent":"","imgUrl":require('../assets/images/management_on@2x.png'),subActions:[
        {"index":1,"FunTitle":"建立可候補排程","actionComponent":"TemplateSchedule","imgUrl":require('../assets/images/calendar_on@2x.png')},
        {"index":2,"FunTitle":"候補管理","actionComponent":"WaitlistAdmin","imgUrl":require('../assets/images/appointment_on@2x.png')},
        {"index":3,"FunTitle":"預約管理","actionComponent":"ReservationAdmin","imgUrl":require('../assets/images/appointment_on@2x.png')},
      ]},*/
      {"index":4,"FunTitle":"請款/核銷","actionComponent":"","imgUrl":require('../assets/images/management_on@2x.png'),subActions:[
          {"index":1,"FunTitle":"核銷紀錄查詢","pathName": "service_execution_list","actionComponent":"ServiceExecutionList","imgUrl":require('../assets/images/appointment_on@2x.png')},
          {"index":2,"FunTitle":"核銷日曆查看","pathName": "service_execution_view","actionComponent":"ServiceExecutionView","imgUrl":require('../assets/images/appointment_on@2x.png')},
          {"index":3,"FunTitle":"請款單查看","pathName": "paymentform_manage","actionComponent":"PaymentFormAdminView","imgUrl":require('../assets/images/appointment_on@2x.png')},
      ]},
      {"index":5,"FunTitle":"用戶評價查詢","pathName": "user_score_manage","actionComponent":"UserScoreManage","imgUrl":require('../assets/images/management_on@2x.png')},
      {"index":6,"FunTitle":"票券處理","pathName": "ticket_process","actionComponent":"TicketProcess","imgUrl":require('../assets/images/management_on@2x.png')},
      {"index":7,"FunTitle":"訂單查詢處理","pathName": "orders","actionComponent":"OrderProcess",faicon:"receipt"},
    ],
    'admin_support': [
      //{"index":0,"FunTitle":"做預約","actionComponent":"MakeReservation","imgUrl":require('../assets/images/appointment_on@2x.png')},
      {"index":0,"FunTitle":"統計報表","actionComponent":"","imgUrl":require('../assets/images/money_on@2x.png'),subActions:[  
        {"index":1,"FunTitle":"回兌狀態","pathName": "ticket_report","actionComponent":"SalesViewTicketReport","imgUrl":require('../assets/images/management_on@2x.png')}, 
        {"index":2,"FunTitle":"課程核銷狀態","pathName": "ticket_status_report","actionComponent":"SalesViewTicketStatus","imgUrl":require('../assets/images/management_on@2x.png')},  
        {"index":3,"FunTitle":"核銷失敗紀錄","pathName": "ticket_error_report","actionComponent":"StatisticsTicketError","imgUrl":require('../assets/images/management_on@2x.png')} 
      ]},
      {"index":1,"FunTitle":"課程管理","pathName": "ticket_manage","actionComponent":"Tickets","imgUrl":require('../assets/images/ticket_on@2x.png')},
      {"index":2,"FunTitle":"供應商管理","pathName": "merchant_manage","actionComponent":"MerchantManage","imgUrl":require('../assets/images/management_on@2x.png')},
      {"index":3,"FunTitle":"請款/核銷","actionComponent":"","imgUrl":require('../assets/images/management_on@2x.png'),subActions:[
          {"index":1,"FunTitle":"核銷紀錄查詢","pathName": "service_execution_list","actionComponent":"ServiceExecutionList","imgUrl":require('../assets/images/appointment_on@2x.png')},
          {"index":2,"FunTitle":"核銷日曆查看","pathName": "service_execution_view","actionComponent":"ServiceExecutionView","imgUrl":require('../assets/images/appointment_on@2x.png')},
          {"index":3,"FunTitle":"請款單查看","pathName": "paymentform_manage","actionComponent":"PaymentFormAdminView","imgUrl":require('../assets/images/appointment_on@2x.png')},
        ]},
      {"index":4,"FunTitle":"票券處理","pathName": "ticket_process","actionComponent":"TicketProcess","imgUrl":require('../assets/images/management_on@2x.png')},
      {"index":5,"FunTitle":"用戶評價查詢","pathName": "user_score_manage","actionComponent":"UserScoreManage","imgUrl":require('../assets/images/management_on@2x.png')},
      //{"index":5,"FunTitle":"店家劃位爭議處理","actionComponent":"StoreRsvHisManage","imgUrl":require('../assets/images/management_on@2x.png')},
      {"index":6,"FunTitle":"訂單查詢處理","pathName": "orders","actionComponent":"OrderProcess",faicon:"receipt"},
      {"index":7,"FunTitle":"會員繼承","pathName": "member_process","actionComponent":"MemberProcess",faicon:"angry"},
    ],
    'admin_mgr_dept': [
      {"index":0,"FunTitle":"課程管理","pathName": "ticket_manage","actionComponent":"Tickets","imgUrl":require('../assets/images/ticket_on@2x.png')},
      {"index":1,"FunTitle":"供應商管理","pathName": "merchant_manage","actionComponent":"MerchantManage","imgUrl":require('../assets/images/management_on@2x.png')},
      {"index":2,"FunTitle":"銷售管理組合","pathName": "sales_statistics","actionComponent":"SalesViewCombo","imgUrl":require('../assets/images/appointment_on@2x.png')},
      {"index":3,"FunTitle":"請款/核銷","actionComponent":"","imgUrl":require('../assets/images/management_on@2x.png'),subActions:[
          {"index":1,"FunTitle":"核銷紀錄查詢","pathName": "service_execution_list","actionComponent":"ServiceExecutionList","imgUrl":require('../assets/images/appointment_on@2x.png')},
          {"index":2,"FunTitle":"核銷日曆查看","pathName": "service_execution_view","actionComponent":"ServiceExecutionView","imgUrl":require('../assets/images/appointment_on@2x.png')},
          {"index":3,"FunTitle":"請款單查看","pathName": "paymentform_manage","actionComponent":"PaymentFormAdminView","imgUrl":require('../assets/images/appointment_on@2x.png')},
        ]},
      {"index":4,"FunTitle":"票券處理","pathName": "ticket_process","actionComponent":"TicketProcess","imgUrl":require('../assets/images/management_on@2x.png')},
      //需要的各種操作集中在一個功能裡面,包括票券逾期已領回上傳更新與之後需要的手動票券回兌相關功能
      {"index":5,"FunTitle":"訂單查詢處理","pathName": "orders","actionComponent":"OrderProcess",faicon:"receipt"},
      {"index":6,"FunTitle":"放款作業","pathName": "payment_operation","actionComponent":"PaymentOperation",faicon:"money-bill"},
      //最後銷毀紙本票前確認作廢由管理部做!?
      {"index":7,"FunTitle":"紙本票銷退作廢","pathName": "paper_ticket_return","actionComponent":"PaperSalesReturn",faicon:"receipt"},
      //{"index":7,"FunTitle":"票券回兌處理","actionComponent":"UnderConstruction","imgUrl":require('../assets/images/management_on@2x.png')},
    ],
    'admin_logistic': [
      {"index":0,"FunTitle":"紙本票處理","pathName": "print_paper_ticket","actionComponent":"PrintTest",faicon:"print"},
      {"index":1,"FunTitle":"訂單查詢處理","pathName": "orders","actionComponent":"OrderProcess",faicon:"receipt"},
      {"index":2,"FunTitle":"紙本票銷退作廢","pathName": "paper_ticket_return","actionComponent":"PaperSalesReturn",faicon:"receipt"},
    ],
    'admin_logistic_small': [
      // {"index":0,"FunTitle":"紙本票處理","actionComponent":"PrintTest",faicon:"print"},
      // {"index":1,"FunTitle":"訂單查詢處理","actionComponent":"OrderProcess",faicon:"receipt"},
      {"index":0,"FunTitle":"紙本票銷退作廢","pathName": "paper_ticket_return","actionComponent":"PaperSalesReturn",faicon:"receipt"},
    ],
    'merchant_admin': [
      {"index":0,"FunTitle":"重要訊息","pathName": "info","actionComponent":"Info","imgUrl":require('../assets/images/notification_on@2x.png')},
      //{"index":1,"FunTitle":"建立可候補排程","actionComponent":"TemplateSchedule","imgUrl":require('../assets/images/calendar_on@2x.png')},
      //{"index":2,"FunTitle":"候補管理","actionComponent":"WaitlistAdmin","imgUrl":require('../assets/images/appointment_on@2x.png')},
      {"index":1,"FunTitle":"銷售管理組合","pathName": "sales_statistics","actionComponent":"SalesViewCombo","imgUrl":require('../assets/images/appointment_on@2x.png')},
      {"index":2,"FunTitle":"核銷日曆查看","pathName": "service_execution_view","actionComponent":"ServiceExecutionView","imgUrl":require('../assets/images/appointment_on@2x.png')},
      {"index":3,"FunTitle":"分店管理","pathName": "store_manage","actionComponent":"MerchantManage","imgUrl":require('../assets/images/management_on@2x.png')},
      {"index":4,"FunTitle":"請款作業","pathName": "paymentform_manage","actionComponent":"PaymentFormAdminView","imgUrl":require('../assets/images/appointment_on@2x.png')},
      {"index":5,"FunTitle":"核銷紀錄查詢","pathName": "service_execution_list","actionComponent":"ServiceExecutionList","imgUrl":require('../assets/images/appointment_on@2x.png')},
    ],
    'merchant_store': [
      {"index":0,"FunTitle":"重要訊息","pathName": "info","actionComponent":"Info",faicon:"exclamation-circle"},
      {"index":1,"FunTitle":"銷售管理組合","pathName": "sales_statistics","actionComponent":"SalesViewCombo",faicon:"chart-line"},
      {"index":2,"FunTitle":"請款/核銷","actionComponent":"",faicon:"hand-holding-usd",subActions:[
          {"index":1,"FunTitle":"核銷","pathName":"store_service_execution","actionComponent":"StoreServiceExecution","imgUrl":require('../assets/images/appointment_on@2x.png')},
          {"index":2,"FunTitle":"核銷日曆查看","pathName": "service_execution_view","actionComponent":"ServiceExecutionView","imgUrl":require('../assets/images/appointment_on@2x.png')},
          {"index":3,"FunTitle":"核銷紀錄查詢","pathName": "service_execution_list","actionComponent":"ServiceExecutionList","imgUrl":require('../assets/images/appointment_on@2x.png')},
          //{"index":4,"FunTitle":"請款作業","actionComponent":"PaymentFormAdminView","imgUrl":require('../assets/images/appointment_on@2x.png')},
        ]
      },
      /*{"index":3,"FunTitle":"劃位設定","actionComponent":"",faicon:"cogs",subActions:[
        {"index":1,"FunTitle":"休息時段","actionComponent":"StoreRestTimeManage","imgUrl":require('../assets/images/appointment_on@2x.png')},
        {"index":2,"FunTitle":"自動接受劃位","actionComponent":"StoreAutoAcceptManage","imgUrl":require('../assets/images/appointment_on@2x.png')},
        {"index":3,"FunTitle":"公休日","actionComponent":"StoreRestDayApply","imgUrl":require('../assets/images/appointment_on@2x.png')},
        {"index":4,"FunTitle":"自訂外部劃位","actionComponent":"StoreExtRvTypeManage","imgUrl":require('../assets/images/appointment_on@2x.png')},
      ]},
      {"index":4,"FunTitle":"預約管理","actionComponent":"",faicon:"calendar",subActions:[
        {"index":1,"FunTitle":"每日預約檢視","actionComponent":"StoreRcManage","imgUrl":require('../assets/images/appointment_on@2x.png')},
        {"index":2,"FunTitle":"預約管理","actionComponent":"StoreReservationList","imgUrl":require('../assets/images/appointment_on@2x.png')},
        {"index":3,"FunTitle":"劃位邀請與確認","actionComponent":"StoreApplyManage","imgUrl":require('../assets/images/appointment_on@2x.png')},
        {"index":4,"FunTitle":"顧客好友維護","actionComponent":"UnderConstruction","imgUrl":require('../assets/images/appointment_on@2x.png')},
        //{"index":5,"FunTitle":"組件測試","actionComponent":"StoreRcView","imgUrl":require('../assets/images/appointment_on@2x.png')},
      ]},
      {"index":5,"FunTitle":"課程檢視/操作","actionComponent":"",faicon:"ticket-alt",subActions:[
        {"index":1,"FunTitle":"配合課程管理","actionComponent":"UnderConstruction","imgUrl":require('../assets/images/appointment_on@2x.png')},
        {"index":2,"FunTitle":"課程票券","actionComponent":"UnderConstruction","imgUrl":require('../assets/images/appointment_on@2x.png')},
        {"index":3,"FunTitle":"課程劃位","actionComponent":"UnderConstruction","imgUrl":require('../assets/images/appointment_on@2x.png')},
      ]},*/
      {"index":3,"FunTitle":"子帳號管理","pathName": "merchant_manage","actionComponent":"MerchantManage",faicon:"user-circle"},
      {"index":4,"FunTitle":"聊天劃位","pathName": "chatroom","actionComponent":"Chatroom",faicon:"comments"},
    ],
    'merchant_store_manager': [
      //spalogin上線時Info也打掉不要,讓店家去聊天室和劃位申請功能去按就好
      {"index":0,"FunTitle":"重要訊息","pathName": "info","actionComponent":"Info",faicon:"exclamation-circle"},
      {"index":1,"FunTitle":"銷售管理組合","pathName": "chatroom","actionComponent":"SalesViewCombo",faicon:"chart-line"},
      {"index":2,"FunTitle":"請款/核銷","pathName": "sales_statistics","actionComponent":"",faicon:"hand-holding-usd",subActions:[
          {"index":1,"FunTitle":"核銷","pathName":"store_service_execution","actionComponent":"StoreServiceExecution","imgUrl":require('../assets/images/appointment_on@2x.png')},
          {"index":2,"FunTitle":"核銷日曆查看","pathName": "service_execution_view","actionComponent":"ServiceExecutionView","imgUrl":require('../assets/images/appointment_on@2x.png')},
          {"index":3,"FunTitle":"核銷紀錄查詢","pathName": "service_execution_list","actionComponent":"ServiceExecutionList","imgUrl":require('../assets/images/appointment_on@2x.png')},
          //{"index":4,"FunTitle":"請款作業","actionComponent":"PaymentFormAdminView","imgUrl":require('../assets/images/appointment_on@2x.png')},
        ]
      },
      {"index":3,"FunTitle":"聊天劃位","pathName": "chatroom","actionComponent":"Chatroom",faicon:"comments"},
    ],
    'merchant_store_operator': [
      {"index":0,"FunTitle":"重要訊息","pathName": "info","actionComponent":"Info",faicon:"exclamation-circle"},
      {"index":1,"FunTitle":"核銷","actionComponent":"",faicon:"hand-holding-usd",subActions:[
          {"index":1,"FunTitle":"核銷","pathName":"store_service_execution","actionComponent":"StoreServiceExecution","imgUrl":require('../assets/images/appointment_on@2x.png')},
          {"index":2,"FunTitle":"核銷日曆查看","pathName": "service_execution_view","actionComponent":"ServiceExecutionView","imgUrl":require('../assets/images/appointment_on@2x.png')},
          {"index":3,"FunTitle":"核銷紀錄查詢","pathName": "service_execution_list","actionComponent":"ServiceExecutionList","imgUrl":require('../assets/images/appointment_on@2x.png')},
        ]
      },
      //{"index":3,"FunTitle":"聊天劃位","actionComponent":"UnderConstruction",faicon:"comments"},
    ],
    'user': [
      {"index":0,"FunTitle":"重要訊息","pathName": "info","actionComponent":"Info","imgUrl":require('../assets/images/notification_on@2x.png')},
      {"index":1,"FunTitle":"做預約","pathName": "make_reservation","actionComponent":"MakeReservation","imgUrl":require('../assets/images/appointment_on@2x.png')},
    ]
  },
  remainBalance: 0,
  pageCodeMapper: {
    Login: {
      code: 1,
      name: '登入'
    },
    Statistics: {
      code: 2,
      name: 'API呼叫'
    },
    SalesViewTicketReport: {
      code: 3,
      name: '回兌狀態'
    },
    SalesViewTicketStatus: {
      code: 4,
      name: '課程核銷狀態'
    },
    StatisticsTicketError: {
      code: 5,
      name: '核銷失敗紀錄'
    },
    Ticket: {
      code: 6,
      name: '課程管理'
    },
    SalesViewCombo: {
      code: 7,
      name: '銷售數據'
    },
    ReservationChart: {
      code: 8,
      name: '預約數據'
    },
    MerchantManage: {
      code: 9,
      name: '供應商管理'
    },
    ServiceExecutionList: {
      code: 10,
      name: '核銷紀錄查詢'
    },
    ServiceExecutionView: {
      code: 11,
      name: '核銷日曆查看'
    },
    PaymentFormAdminView: {
      code: 12,
      name: '請款單查看'
    },
    TicketProcess: {
      code: 13,
      name: '票券處理'
    },
    UserScoreManage: {
      code: 14,
      name: '用戶評價查詢'
    },
    OrderProcess: {
      code: 15,
      name: '訂單查詢處理'
    },
    MemberProcess: {
      code: 16,
      name: '會員繼承'
    },
    PrintTest: {
      code: 17,
      name: '紙本票處理'
    },
    PaperSalesReturn: {
      code: 18,
      name: '紙本票銷退作廢'
    },
    PaymentOperation: {
      code: 19,
      name: '放款作業'
    }

  }
}
